import { createSlice, } from '@reduxjs/toolkit'

const initialState = {
  pendingOrders : null,
  contact : '',
  profileIsOpen : false,
  orderDetailIsOpen: false,
  amountCalIsOpen: false,
  shipDatePaymentIsOpen: false,
  existingPaymentLink: null // Add this to store existing payment link info
}

const keyDataSlice = createSlice({
  name: "keyData",
  initialState,
  reducers: {
    setKeyDataPendingOrders: (state, action) => {
      state.pendingOrders = action.payload;
    },
    setKeyDataContact: (state, action) => {
      state.contact = action.payload;
    },
    setProfileIsOpen: (state,action) => {
      state.profileIsOpen = action.payload
    },
    setOrderDetailIsOpen: (state,action) => {
      state.orderDetailIsOpen = action.payload
    },
    setAmountCalIsOpen: (state,action) => {
      state.amountCalIsOpen = action.payload
    },
    setShipDatePaymentIsOpen: (state,action) => {
      state.shipDatePaymentIsOpen = action.payload
    },
    setExistingPaymentLink: (state, action) => {
      state.existingPaymentLink = action.payload
    },
  },
});

export const selectKeyDataPendingOrders = (state) => state.keyData.pendingOrders
export const selectKeyDataContact = (state) => state.keyData.contact
export const selectProfileIsOpen = (state) => state.keyData.profileIsOpen
export const selectOrderDetailIsOpen = (state) => state.keyData.orderDetailIsOpen
export const selectAmountCalIsOpen = (state) => state.keyData.amountCalIsOpen
export const selectShipDatePaymentIsOpen = (state) => state.keyData.shipDatePaymentIsOpen
export const selectExistingPaymentLink = (state) => state.keyData.existingPaymentLink

export const { 
  setKeyDataPendingOrders, 
  setKeyDataContact, 
  setProfileIsOpen, 
  setOrderDetailIsOpen, 
  setAmountCalIsOpen, 
  setShipDatePaymentIsOpen,
  setExistingPaymentLink 
} = keyDataSlice.actions;
export default keyDataSlice.reducer